//region 1. Platform Libraries
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import { logger } from '../DataAPI';
//endregion

export default function checkObjectID(req, res, next) {
    const log = (lvl, msg) => logger.log(lvl, msg, { tags: 'checkObjectID' });
    log('debug', JSON.stringify(req.params, null, 2));
    const id = req.params.id;
    if (!id) {
        const message = 'No ID';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    try {
        MongoClient.ObjectID(id);
    } catch (err) {
        log('error', err.message);
        res.status(400).send(err.message);
        return;
    }
    next();
}
